//Search Assistant
export const CONTENT_FILTERING_DOWN_ERROR = "SF-OAI-CF-501";
export const CONTENT_FILTERING_TRIGGERED = "SF-OAI-CF-400";
export const SHAREPOINT_DOCUMENT_NOT_FOUND = "SF-DOC-DB-404";
export const COSMOS_THROTTLING_ERROR = "SF-DOC-DB-429";
